var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 14,
    clipPath: "url(#clip0_2_56)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1323,
    transform: "translate(-266 -726)",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1035"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -75.5,
    y: -546.5,
    width: 499,
    height: 730,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -75.5,
    y: -546.5,
    width: 499,
    height: 730,
    rx: 7.5,
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1866"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -32,
    width: 112,
    height: 112,
    rx: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z",
    fill: "#6164A5"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1323,
    fill: "white",
    transform: "translate(-266 -726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.419fc16bd68ca83c6a41fd28520a34f8.svg";
export { ForwardRef as ReactComponent };